import React from 'react';
import { fill, signed } from './labels';

// Three rows. "Kapasitas terpakai" from the canvas is absent by design: no capacity
// column exists on participants, orders or hospitals (PE-440 plan, gap G4).
export default function InsightCard({ summary, labels }) {
  var median = summary && summary.median_wait_minutes;
  var excluded = (summary && summary.median_wait_excluded) || 0;
  var busiest = summary && summary.busiest_hour;
  var delta = (summary && summary.delta_vs_previous_day) || 0;

  var rows = [
    {
      key: 'median',
      icon: 'zmdi-time-interval',
      label: labels.median_wait,
      value: median === null || median === undefined
        ? labels.not_available
        : fill(labels.median_wait_value, { median: median }),
      note: median !== null && median !== undefined && excluded > 0
        ? fill(labels.median_wait_excluded, { count: excluded })
        : null
    },
    {
      key: 'busiest',
      icon: 'zmdi-chart',
      label: labels.busiest_hour,
      value: busiest === null || busiest === undefined
        ? labels.not_available
        : String(busiest).padStart(2, '0') + ':00 – ' + String((busiest + 1) % 24).padStart(2, '0') + ':00'
    },
    {
      key: 'delta',
      icon: 'zmdi-swap-vertical',
      label: labels.vs_yesterday,
      value: fill(labels.vs_yesterday_value, { sign: signed(delta), count: delta })
    }
  ];

  return (
    <div className="card ehc-monitoring__card">
      <div className="card-header ehc-monitoring__card-header">
        <span className="ehc-monitoring__eyebrow">{labels.eyebrow}</span>
      </div>
      <div className="card-body">
        {rows.map(function (row) {
          return (
            <div className="ehc-monitoring__insight-row" key={row.key}>
              <i className={'zmdi ' + row.icon} />
              <span className="ehc-monitoring__insight-label">
                {row.label}
                {row.note && <small className="ehc-monitoring__insight-note">{row.note}</small>}
              </span>
              <span className="ehc-monitoring__insight-value">{row.value}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
